var $ = require('jQuery');
var tectoastr = require('tectoastr');

module.exports = function() {
    $('#btn-copy').click(function(e) {
        var $temp = $("<textarea>");
        $("body").append($temp);
        $temp.val($("#formatted-content").text()).select();
        document.execCommand("copy");
        $temp.remove();

        tectoastr.info($("#copied-message").text());
    });
};
